export enum OrderStatus{
    PENDING = 'PENDING',
    COMPLETE = 'COMPLETE',
    PROCESSED = 'PROCESSED',
    CANCELED = "CANCELED"
}